import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { ApiConnectionString } from "../../../constants/ApiConntection";
import { useAuthContext } from "../../../hooks/useAuthContext";
import LoadingSpinner from "../../../components/LoadingSpinner";

export default function DeleteProductModal({ cancelModal, product }) {
  //styled
  const { user } = useAuthContext();
  const [isLoading, setIsLoading] = useState(false);
  const [prodDelete, setProdDeleted] = useState(false);
  const navi = useNavigate();

  const handleClick = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const deleteResponse = await axios.delete(
        `${ApiConnectionString}/api/product/${product.id}`,
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );

      if (deleteResponse.status === 200) {
        setProdDeleted(true);
      }
    } catch (error) {
      console.error("Error deleting the product:", error);
      // Optionally handle error here, such as showing a notification
    } finally {
      setIsLoading(false); // Always stop loading, even if an error occurs
    }
  };

  if (isLoading) {
    return (
      <div className="send-modal-overlay">
        <div className="send-modal">
          <LoadingSpinner />
          <div className="send-modal-footer"></div>
        </div>
      </div>
    );
  } else {
    if (!prodDelete) {
      return (
        <div className="send-modal-overlay">
          <div className="send-modal">
            <div className="blueBanner">
              <p className="fw-bold m-2 p-2 fontSize20">Delete Product</p>
            </div>

            <button
              type="button"
              className="close-button"
              onClick={cancelModal}
              aria-label="Close"
            >
              &times;
            </button>

            <p>Are you sure you want to delete this product?</p>

            <div className="send-modal-footer">
              <button className="saveChanges-button mx-3" onClick={handleClick}>
                Confirm
              </button>
              <button
                onClick={cancelModal}
                className="pointer cancelButton fw-bold mx-2 px-3"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div className="send-modal-overlay">
          <div className="send-modal">
            <div className="blueBanner">
              <p className="fw-bold m-2 p-2 fontSize20">Product Deleted</p>
            </div>
            <p>The product was deleted successfully.</p>

            <div className="send-modal-footer">
              <button
                className="pointer cancelButton fw-bold mx-2 px-3"
                onClick={() => {
                  cancelModal();
                  navi(`/myoneclub/${product.clubId}/PaymentOptions`);
                }}
              >
                Okay
              </button>
            </div>
          </div>
        </div>
      );
    }
  }
}
